/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'

export function StarIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M19.3533 7.59833C19.2752 7.35812 19.1277 7.1464 18.9295 6.98986C18.7312 6.83331 18.4911 6.73895 18.2393 6.71864L13.6299 6.34677L11.8502 2.04286C11.754 1.80834 11.5902 1.60774 11.3796 1.46656C11.1691 1.32538 10.9213 1.25 10.6678 1.25C10.4143 1.25 10.1665 1.32538 9.95598 1.46656C9.74544 1.60774 9.58163 1.80834 9.48538 2.04286L7.70725 6.34599L3.09554 6.71864C2.84333 6.73997 2.60303 6.83525 2.40473 6.99255C2.20644 7.14985 2.05898 7.36217 1.98082 7.6029C1.90266 7.84364 1.89728 8.10209 1.96535 8.34587C2.03343 8.58965 2.17193 8.80792 2.3635 8.97333L5.87913 12.0069L4.80804 16.5429C4.74813 16.7893 4.7628 17.048 4.85018 17.286C4.93755 17.5241 5.09369 17.7309 5.29879 17.88C5.50388 18.0292 5.74867 18.1141 6.00208 18.1239C6.25549 18.1337 6.5061 18.0679 6.7221 17.935L10.6674 15.5069L14.6151 17.935C14.8311 18.0664 15.0812 18.1308 15.3339 18.1203C15.5865 18.1098 15.8304 18.0247 16.0348 17.8759C16.2391 17.727 16.3949 17.521 16.4825 17.2838C16.57 17.0466 16.5855 16.7888 16.5268 16.5429L15.4518 12.0061L18.9674 8.97255C19.1605 8.80741 19.3003 8.58867 19.369 8.34403C19.4377 8.09939 19.4323 7.83987 19.3533 7.59833Z"
        fill="#FFC03A"
      />
    </svg>
  )
}
